/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellModelExport } from "./CellModelExport";
import { DataSourceSchemaPropertyType_$type } from "igniteui-react-core";
import { enumGetBox, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var EditorCellModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditorCellModelExport, _super);
    function EditorCellModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.af = false;
        _this.ag = null;
        _this.ae = 0;
        _this.ah = null;
        return _this;
    }
    EditorCellModelExport.prototype.get_ac = function () {
        return "EditorCell";
    };
    EditorCellModelExport.prototype.ad = function (a) {
        _super.prototype.ad.call(this, a);
        a.l("isHidden: " + this.af.toString().toLowerCase() + ", ");
        a.l("editValue: '" + this.ag + "', ");
        a.l("dataType: '" + enumGetBox(DataSourceSchemaPropertyType_$type, this.ae) + "', ");
        a.l("errorMessage: '" + this.ah + "', ");
    };
    EditorCellModelExport.$t = markType(EditorCellModelExport, 'EditorCellModelExport', CellModelExport.$);
    return EditorCellModelExport;
}(CellModelExport));
export { EditorCellModelExport };
//# sourceMappingURL=EditorCellModelExport.js.map
